import React, { useContext } from 'react'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { Relative, Absolute, Image } from 'pcln-design-system'
import BootstrapDataContext from '../../context/BootstrapDataContext'

const StyledContent = styled(Relative)`
  max-width: 1280px;
  margin: 0 auto;
`
const StyledAbsolute = styled(Absolute)`
  overflow: hidden;
  z-index: -1;
`

const StyledImage = styled(Image)`
  ${themeGet('mediaQueries.xxl')} {
    height: auto;
  }
`

type HeroProps = {
  img: string
  children: JSX.Element
  description?: string
}

export default function HeroImage({
  img,
  children,
  description = 'Hero background Image'
}: HeroProps) {
  const { isTablet = false } = useContext(BootstrapDataContext)
  return (
    <Relative>
      <StyledContent zIndex={10} pt={4} pb="40px" px={4}>
        {children}
      </StyledContent>
      <StyledAbsolute top={0} height="100%">
        <StyledImage
          src={img}
          alt={description}
          isTablet={isTablet}
          className="hero-image"
          width={1}
          height="100%"
        />
      </StyledAbsolute>
    </Relative>
  )
}
